import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { t } from '@/i18n';
import { skipRowNav } from './rowNav';

/**
 * Hover copy affordance for one cell value; doesn't trigger the row click.
 * Reveals on `group` hover — the TableRow must carry the `group` class.
 * Suppresses row navigation via the skipRowNav flag (NOT stopPropagation),
 * so the host row's onClick must check isRowNavHandled.
 */
export function CopyValueButton({ value }: { value: string }) {
  return (
    <Button
      variant="ghost"
      size="icon"
      className="size-5 shrink-0 opacity-0 group-hover:opacity-100 focus-visible:opacity-100"
      aria-label={t('sales.report.copyValue')}
      onClick={async (e) => {
        skipRowNav(e);
        try {
          await navigator.clipboard.writeText(value);
          toast.success(t('sales.report.copied'));
        } catch {
          toast.error(t('sales.report.copyError'));
        }
      }}
    >
      <Copy className="size-3" />
    </Button>
  );
}
